import { ScrollView } from 'react-native';
import createAnimatedComponent from '../../createAnimatedComponent';

const AnimatedScrollView = createAnimatedComponent(ScrollView);

export default AnimatedScrollView;
